import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-popup-benefit-horizontal',
  template: `
    <div class="benefit_item">
      <div class="benefit_item__icon-container">
        <img class="benefit_item__icon" [src]="src" />
      </div>
      <div class="benefit_item__text-container">
        <div class="benefit_item__heading">{{ heading }}</div>
        {{ text }}
      </div>
    </div>
  `,
  styles: `
    .benefit_item {
      display: flex;
      flex-direction: row;
      gap: 15px;

      &__text-container {
        font-size: 12px;
        text-align: left;
      }

      &__heading {
        font-size: 14px;
        font-weight: bold;
      }

      &__icon-container {
        display: flex;
        align-items: center;
      }

      &__icon {
        width: 43px;
        height: 43px;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupBenefitHorizontalComponent {
  @Input({ required: true }) src: string;
  @Input({ required: true }) heading: string;
  @Input({ required: true }) text: string;
}
